import { OnboardingData } from 'shared/interfaces/Onboarding';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const onboardingBaseEndpoint = '/onboarding';

export const OnboardingService = {
  handleOnboardingData: async (data: OnboardingData): Promise<void> => {
    await axiosBaseInstance({
      method: 'post',
      url: `${onboardingBaseEndpoint}/handle`,
      data
    });
  }
};
